import { Button, Card, CardContent, CardHeader, CardTitle, Input } from "@repo/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";

export default function YumlabHome() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: recipes } = useQuery({
    queryKey: ["recipes"],
    queryFn: async () => {
      const r = await fetch("/api/recipes");
      return (await r.json()) as Array<{
        id: number;
        title: string;
        image: string | null;
        servings: number;
      }>;
    },
  });
  const del = useMutation({
    mutationFn: async (id: number) => {
      await fetch(`/api/recipes/${id}`, { method: "DELETE" });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["recipes"] }),
  });
  const onSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const q = new FormData(e.currentTarget).get("q")?.toString() || "";
    const found = (recipes || []).find((r) => r.title.toLowerCase().includes(q.toLowerCase()));
    if (found) navigate(`/recipes/${found.id}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-mint/20 to-bubblegum/10 text-ink">
      <div className="mx-auto max-w-5xl px-4 py-10 space-y-8">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="size-10 rounded-xl bg-mango grid place-items-center text-ink font-bold">
              Y
            </div>
            <h1 className="font-display text-3xl">Yumlab</h1>
          </div>
          <Button
            onClick={() => navigate("/recipes/new")}
            className="cartoony-btn rounded-full bg-bubblegum text-ink hover:bg-bubblegum/90"
          >
            New recipe
          </Button>
        </header>

        <form onSubmit={onSearch} className="flex gap-3">
          <Input name="q" placeholder="Search recipes" className="rounded-full" />
          <Button
            type="submit"
            className="cartoony-btn rounded-full bg-mint text-ink hover:bg-mint/90"
          >
            Search
          </Button>
        </form>

        <section className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {(recipes || []).map((r) => (
            <Card key={r.id} className="rounded-2xl border-ink/10 hover:border-ink/20 transition">
              <CardHeader>
                <CardTitle className="text-xl font-display truncate">{r.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex items-center justify-between">
                <Link to={`/recipes/${r.id}`} className="text-primary underline underline-offset-4">
                  Open
                </Link>
                <Button
                  variant="ghost"
                  onClick={() => del.mutate(r.id)}
                  className="cartoony-btn text-destructive"
                >
                  Delete
                </Button>
              </CardContent>
            </Card>
          ))}
          {recipes?.length === 0 && (
            <div className="col-span-full text-center text-muted-foreground">
              No recipes yet. Create your first!
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
